<template>
  <div class="text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="600"
      max-width="600"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          small
          color="primary"
          v-bind="attrs"
          v-on="on"
        >
          Filtros
          <v-icon small class="ml-2">mdi-filter-menu-outline</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-title class="font-16">Filtros de produtos</v-list-item-title>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <v-list-item>
            <SysGrupoAutocomplete
              v-model="model_value.grupos"
              outlined
              multiple
              clearable
              hide-details
              label="Grupo"
              class="mt-1 mb-2"
            />
          </v-list-item>

          <v-list-item>
            <SysFilialGrupoAutocomplete
              v-model="model_value.filiais"
              outlined
              multiple
              clearable
              hide-details
              label="Filiais"
              class="mt-1 mb-2"
            />
          </v-list-item>

          <v-list-item>
            <SysSegmentoAutocomplete
              v-model="model_value.segmentos"
              outlined
              multiple
              clearable
              hide-details
              label="Segmentos"
              class="mt-1 mb-2"
            />
          </v-list-item>

          <v-list-item>
            <SysFornecedorAutocomplete
              v-model="model_value.fornecedores"
              outlined
              multiple
              clearable
              hide-details
              label="Fornecedores"
              class="my-2"
            />
          </v-list-item>

          <v-list-item>
            <SysCompradorAutocomplete
              v-model="model_value.compradores"
              outlined
              multiple
              clearable
              hide-details
              label="Compradores"
              class="my-2"
            />
          </v-list-item>

          <slot name="filtros-adicionais"></slot>
        </v-list>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="fecharMenu(true)">Fechar</v-btn>
          <v-btn color="primary" text @click="fecharMenu(false)">Aplicar Filtros</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import SysCompradorAutocomplete from '@/components/utils/crud/SysCompradorAutocomplete.vue';
import SysFornecedorAutocomplete from '@/components/utils/crud/SysFornecedorAutocomplete.vue';
import SysSegmentoAutocomplete from '@/components/utils/crud/SysSegmentoAutocomplete.vue';
import SysGrupoAutocomplete from '@/components/utils/crud/SysGrupoAutocomplete.vue';
import SysFilialGrupoAutocomplete from '@/components/utils/crud/SysFilialGrupoAutocomplete.vue';

export default {
  data: () => ({
    menu: false,
  }),
  methods: {
    resetarFiltros() {
      this.$emit('resetar-filtros');
    },
    aplicarFiltros() {
      this.$emit('aplicar-filtros');
    },
    fecharMenu(reset){
      if (reset) this.resetarFiltros();
      else this.aplicarFiltros();
      this.menu = false;
    },
  },
  props: {
    model_value: {
      type: Object,
      required: true
    }
  },
  model: {
    prop: 'model_value',
    event: 'change:model_value'
  },
  components: {
    SysSegmentoAutocomplete,
    SysFornecedorAutocomplete,
    SysCompradorAutocomplete,
    SysGrupoAutocomplete,
    SysFilialGrupoAutocomplete
},
}
</script>
